import React, { Component } from 'react';
import { connect } from "react-redux"
import { Select, Input } from "../Input/input"
import VoucherMiddleware from "../../store/middleware/voucherMiddleware";
import { Loader } from "../StudentManagment/helper";
import Modal from 'react-responsive-modal';


class PayVoucher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            studentName: "",
            studentFatherName: "",
            studentCnic: "",
            isLoading: false,
            PaymentId: "",
            crrVoucherIndex: null,
            open: false,
            errors: {
                hasError: false,
                errorsObj: {}
            },
            vouchers: []
        }
    }

    componentWillReceiveProps(nextProps) {
        const { errors } = this.state;

        if (nextProps.isError && nextProps.errorMessage) {
            errors.hasError = true;
            errors.simpleError = nextProps.errorMessage;
            this.setState({ errors, vouchers: [] })
            return
        }

        errors.hasError = false;
        errors.simpleError = ""
        console.log(nextProps.vouchers);
        if (nextProps.vouchers.voucherArray) {
            this.setState({
                vouchers: nextProps.vouchers.voucherArray,
                studentName: nextProps.vouchers.studentInfo.fullName,
                studentCnic: nextProps.vouchers.studentInfo.studentCnic,
                studentFatherName: nextProps.vouchers.studentInfo.fatherName,
                fetched: nextProps.fetched,
                errors
            })
        };
    }
    submitPaid = () => {

        const { paymentId, crrVoucherIndex, vouchers } = this.state
        const { valid, studentId, quarter, fee_voucher_no } = vouchers[crrVoucherIndex]
        if (!valid) {
            alert("Voucher Is Invalid")
            return;
        }
        if (!paymentId) {
            alert("Please Provide Payment Id")
            return;
        }
        const data = {
            studentId,
            quarter,
            fee_voucher_no,
            paymentId,
            index: crrVoucherIndex
        }
        this.setState({ crrVoucherIndex: null, paymentId: "", open: false })
        this.props.statusVoucherUpdate(data)
    }


    search = (ev) => {
        ev.preventDefault();
        this.setState({ studentName: "" });
        const { identity, identityValue, } = this.state;
        this.props.search({ type: identity, value: identityValue });
    }

    render() {
		const { errors, vouchers, fetched, studentName, studentFatherName, studentCnic } = this.state;
		const { isLoading } = this.props

        return (
            <div className="container-fluid">
                {isLoading && <Loader />}
                <div className="container">
                    <div className="form-container  align-items-center">
                        <div className="form-wrapper">
                            <Modal open={this.state.open} onClose={() => this.setState({ crrVoucherIndex: null, paymentId: "", open: false })} >
                                <Input
                                    label="Payment Id Of Voucher"
                                    type="text"
                                    name="paymentId"
                                    id="paymentId"
                                    onChange={(ev) => this.setState({ [ev.target.name]: ev.target.value })}
                                    errors={errors}

                                />
                                <br />
                                <button className="my-btn-2" onClick={() => this.submitPaid()} type="button">Submit Voucher</button>
                            </Modal>
                            <form onSubmit={(ev) => this.search(ev)} method="post">
                                <h3>Search Student Voucher</h3>
                                {errors.hasError && <p className="error">{errors.simpleError}</p>}
                                <Select
                                    label="Select Identity"
                                    name="identity"
                                    id="identity"
                                    options={[
                                        { name: "CNIC", value: "cnic" },
                                        { name: "Number", value: "phoneNumber" },
                                        { name: "Roll Number", value: "rollNo" },
                                        { name: "Email", value: "email" },
                                    ]}
                                    onChange={(ev) => this.setState({ [ev.target.name]: ev.target.value })}
                                    errors={errors}
                                />
                                <Input
                                    label="Value"
                                    type="text"
                                    name="identityValue"
                                    id="identityValue"
                                    onChange={(ev) => this.setState({ [ev.target.name]: ev.target.value })}
                                    errors={errors}

                                />
                                <button className="my-btn-2" type="submit">Search</button>
                            </form>
                        </div>
                        {studentName &&
                            // <div>
                            <div className="" >
                                <table className="table  my-table" >
                                    <tbody>
                                        <tr><th >Name</th><td>{studentName}</td></tr>
                                        <tr><th >Father Name</th><td>{studentFatherName}</td></tr>
                                        <tr><th >Student Cnic</th><td>{studentCnic}</td></tr>
                                    </tbody>
                                </table>
                                <br /> <br />
                            </div>
                        }
                        {!!vouchers.length &&

                            <div className="form-wrapper-7">
                                {/* <h3>{voucher.quarter}</h3> */}
                                <div className="table-responsive" >
                                    <table className="table my-table" >
                                        <tbody>
                                            <tr>
                                                <th>Voucher Number</th>
                                                <th>Valid</th>
                                                <th>Status</th>
                                                <th>Roll No</th>
                                                <th>Course</th>
                                                <th>Batch</th>
                                                <th>Distance Learning</th>
                                                <th>Center Name</th>
                                                <th>Center Campus</th>
                                                <th>Class Time</th>
                                                <th>City Of Study</th>
                                                <th>Fee Amount</th>
                                                <th>Quarter</th>
                                                <th>Payment Deadline</th>
                                                <th></th>
                                            </tr>
                                            {
                                                vouchers.map((voucher, index) => {
                                                    return (

                                                        <tr key={index}>
                                                            <td>{voucher.fee_voucher_no}</td>
                                                            <td>{voucher.valid ? "valid" : "date-expired"}</td>
                                                            <td>{voucher.paid ? "Paid" : "Un-Paid"}</td>
                                                            <td>{voucher.rollNo}</td>
                                                            <td>{voucher.course}</td>
                                                            <td>{voucher.batch}</td>
                                                            <td>{`${voucher.distanceLearning}`}</td>
                                                            <td>{voucher.centerName}</td>
                                                            <td>{voucher.centerCampus}</td>
                                                            <td>{voucher.centerTime}</td>
                                                            <td>{voucher.cityOfStudy}</td>
                                                            <td>{voucher.feeAmount}</td>
                                                            <td>{voucher.quarter}</td>
                                                            <td>{voucher.paymentDeadline}</td>
                                                            {voucher.valid && !voucher.paid ?
                                                                <td>
                                                                    <button className="my-btn-3" onClick={() => this.setState({ crrVoucherIndex: index, open: true })}>Pay</button>
                                                                </td>
                                                                : <td></td>

                                                            }

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                        {!vouchers.length && fetched && "No Voucher Generated Yet"}
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        isLoading: state.voucherReducer.isLoading,
        isError: state.voucherReducer.isError,
        errorMessage: state.voucherReducer.errorMessage,
        successMessage: state.voucherReducer.successMessage,
        vouchers: state.voucherReducer.vouchers,
        fetched: state.voucherReducer.fetched
    }
}
function mapDispatchToProps(dispatch) {
    return {
        search: data => {
            dispatch(VoucherMiddleware.search(data));
        },
        statusVoucherUpdate: (data) => {
            dispatch(VoucherMiddleware.statusVoucherUpdate(data));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PayVoucher);